<script lang="ts">
  import { fetchShopifyProductData } from "../../lib";
  import { ShopifyProductStore } from "../../lib/stores/plans";

  interface ProductOption {
    name: string;
    values: string[];
  }

  interface Product {
    title: string;
    images: { src: string }[];
    options?: ProductOption[];
  }

  interface LogType {
    productUrl: string;
  }

  export let log: LogType;
  export let overrideStyleRow = "";
  export let isFirstBubble = false;

  let product: Product | undefined;
  let fetchFailed = false;
  let colorOption: string[] | undefined;
  let cache: Record<string, Product> = {};

  const setProductData = async (productUrl: string) => {
    try {
      if (cache && cache[productUrl]) {
        product = cache[productUrl];
        if (product) {
          setColorOption(product);
        }
        return;
      }

      const productData = await fetchShopifyProductData(productUrl);
      product = productData.product;
      if (product) {
        setColorOption(product);
        updateCache(productUrl, product);
      }
    } catch (error) {
      fetchFailed = true;
    }
  };

  const updateCache = (productUrl: string, product: Product) => {
    ShopifyProductStore.update((store: Record<string, Product>) => {
      store[productUrl] = product;
      return store;
    });
  };

  const setColorOption = (product: Product) => {
    if (!product.options || product.options.length === 0) return;

    const option = product.options.filter((o) => o.name === "Color")[0];

    if (!option) return;

    colorOption = option.values;
  };

  $: setProductData(log.productUrl);
  $: cache = $ShopifyProductStore;
</script>

{#if product && !fetchFailed && product.images && product.images[0]}
  <div
    class="row"
    style={`margin-right: ${isFirstBubble ? "9px" : "39px"}; ${overrideStyleRow}`}
  >
    <div
      class="product-card"
      on:click={() => window.open(log.productUrl, "_blank")}
      on:keydown={(e) =>
        e.key === "Enter" && window.open(log.productUrl, "_blank")}
      role="button"
      tabindex="0"
      aria-label={`View product: ${product?.title || "Product"}`}
    >
      <img
        class="product-img"
        src={product.images[0].src}
        alt={product.title || "Product image"}
      />

      <div class="product-info">
        <div class="product-title">{product.title}</div>
        {#if colorOption}
          <div class="product-option">{colorOption[0]}</div>
          {#if colorOption.length > 1}
            <div class="addl-count">+{colorOption.length - 1}</div>
          {/if}
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .row {
    margin-right: 9px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .product-card {
    cursor: pointer;
    width: 280px;
    border-radius: 10px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12);
    background: white;
    border: none;
    padding: 0;
    text-align: left;
  }

  .product-img {
    width: 100%;
    height: 213px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
  }

  .product-info {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 18px 15px;
    overflow: hidden;
    color: #000;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    line-height: normal;
    font-weight: 400;
  }

  .product-title {
    font-weight: 600;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
  }

  .product-option {
    font-size: 13px;
  }

  .addl-count {
    font-size: 13px;
  }
</style>
